export default "__VITE_ASSET__CGMIM7sq__"